export const zdfColors = {
    // Text
    colorTextPrimary: "#2D3746",
    colorTextSecondaryOnLightColorBg: "#FFFFFF",
    colorTextSecondary: "#ABAFB5",
    colorTextHint: "#9698A2",
    colorTextDisabled: "#9698A2",
    colorTextWarning: "#B50011",
    colorTextSuccess: "#92CD74",
    colorTextHighlight: "#FA7D19",
    colorTextOnBlackBackground: "#FFFFFF",
    colorTextOnDarkBackground: "#FFFFFF",
    colorTextOnLightColorTag: "#2D3746",

    // Button
    colorButtonPrimary: "#FA7D19",
    colorButtonAccent: "#FA7D19",
    // colorButtonSecondary: "#2D3746",
    colorButtonDisabled: "#9698A2",

      // Surface
    colorSurfacePrimary: "#FFFFFF",
    colorSurfaceSecondary: "#FFFFFF",
    colorSurfaceWarning: "#FCEBEA",
    colorSurfaceSuccess: "#B9EBDC",
}

